module.exports = __webpack_public_path__ + "static/media/flowers_9.20932944.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/flowers/flowers_9.csv
// module id = 766
// module chunks = 0